document.addEventListener('DOMContentLoaded', () => {
	const updateCounter = (selector, target, isClient = false) => {
		let count = 0
		const element = document.querySelector(selector)
		const increment = Math.ceil(target / 75)

		const update = () => {
			if (count < target) {
				count += increment
				if (count > target) count = target
				element.textContent = isClient ? count + '+' : count
				requestAnimationFrame(update)
			}
		}
		update()
	}
	let flag = false
	const callback = (entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting && !flag) {
				updateCounter(
					'.clients',
					parseInt(document.querySelector('.clients').textContent, 10),
					true
				)
				updateCounter(
					'.years',
					parseInt(document.querySelector('.years').textContent, 10)
				)
				flag = true
			}
		})
	}

	const observer = new IntersectionObserver(callback)
	observer.observe(document.querySelector('.about-us'))
})
